import React from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { CustomLinkComponent, DynamicTag } from 'msp-components'
import { useWishlist, useConfig, useStandingOrders } from 'msp-integrations'

import WishlistItem from './AccountOverviewWishlist.partials'
import * as S from './AccountOverviewWishlist.styles'

const AccountOverviewWishlist = () => {
  const { formatMessage } = useIntl()
  const wishlist = useWishlist()
  const { getAll } = useStandingOrders()
  const {
    theme: { font }
  } = useConfig()
  const pageLink = '/account/wishlist'
  const subscriptionLink = '/account/subscriptions'
  const MAX_WISHLIST_ITEM_TO_DISPLAY = 6
  const hasTooManyWishlistItems =
    wishlist?.items?.length > MAX_WISHLIST_ITEM_TO_DISPLAY
  const standingOrders = getAll()
  const standingOrdersItems = standingOrders?.flatMap(
    (item) => item.customerProductListItems
  )
  const hasTooManyStandingOrders =
    standingOrdersItems?.length > MAX_WISHLIST_ITEM_TO_DISPLAY

  const messages = defineMessages({
    wishlistTitle: {
      id: 'msp.account.overview.wishlist.title',
      defaultMessage: 'My wishlist'
    },
    wishlistEmpty: {
      id: 'msp.account.overview.wishlist.empty',
      defaultMessage: 'No wishlist items yet'
    },
    subscriptionTitle: {
      id: 'msp.account.overview.subscription.title',
      defaultMessage: 'My subscriptions'
    },
    subscriptionEmpty: {
      id: 'msp.account.overview.subscription.empty',
      defaultMessage: 'No subscriptions have been set up yet'
    }
  })

  return (
    <div className={S.Container}>
      <div className={S.Sections}>
        <DynamicTag
          componentTagName='Headline'
          tag='h3'
          tagStyle='h6'
          className={`${font.regular} ${S.Headline}`}
        >
          {formatMessage(messages.subscriptionTitle)}
        </DynamicTag>
        <div className='flex'>
          {standingOrdersItems
            ?.slice(0, MAX_WISHLIST_ITEM_TO_DISPLAY)
            .map((item) => (
              <WishlistItem
                key={`product-${item.id}`}
                productId={item.productId}
              />
            ))}
          {hasTooManyStandingOrders && (
            <div className={S.WishlistItemRemaining}>
              +{standingOrdersItems?.length - MAX_WISHLIST_ITEM_TO_DISPLAY}
            </div>
          )}
          {standingOrdersItems?.length === 0 && (
            <div className={`${font.regular} ${S.NoItem}`}>
              {formatMessage(messages.subscriptionEmpty)}
            </div>
          )}
        </div>
        <CustomLinkComponent href={subscriptionLink} className={S.BottomLink}>
          {formatMessage(messages.subscriptionTitle)}
        </CustomLinkComponent>
      </div>
      <div className={S.Sections}>
        <DynamicTag
          componentTagName='Headline'
          tag='h3'
          tagStyle='h6'
          className={`${font.regular} ${S.Headline}`}
        >
          {formatMessage(messages.wishlistTitle)}
        </DynamicTag>
        <div className='flex'>
          {wishlist?.items
            ?.slice(0, MAX_WISHLIST_ITEM_TO_DISPLAY)
            .map((item) => (
              <WishlistItem
                key={`product-${item.id}`}
                productId={item.productId}
              />
            ))}
          {hasTooManyWishlistItems && (
            <div className={S.WishlistItemRemaining}>
              +{wishlist?.items?.length - MAX_WISHLIST_ITEM_TO_DISPLAY}
            </div>
          )}
          {wishlist?.isEmpty && (
            <div className={`${font.regular} ${S.NoItem}`}>
              {formatMessage(messages.wishlistEmpty)}
            </div>
          )}
        </div>
        <CustomLinkComponent href={pageLink} className={S.BottomLink}>
          {formatMessage(messages.wishlistTitle)}
        </CustomLinkComponent>
      </div>
    </div>
  )
}

export default AccountOverviewWishlist
